class NodeCode {
  constructor(name, type) {
    let code = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    this.name = name;
    this.type = type;
    this.code = code;
    Object.defineProperty(this, 'isNodeCode', {
      value: true
    });
  }

}

export default NodeCode;